import { useState, useCallback } from "react";
import { api } from "../lib/api";
import type { WhitelistEntry } from "../../api/_lib/types";

export function useWhitelist() {
  const [entries, setEntries] = useState<WhitelistEntry[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await api.whitelist.list();
      setEntries(data.sort((a, b) => b.addedAt - a.addedAt));
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setLoading(false);
    }
  }, []);

  const add = useCallback(async (email: string) => {
    await api.whitelist.add(email);
    await load();
  }, [load]);

  const remove = useCallback(async (email: string) => {
    await api.whitelist.remove(email);
    setEntries(prev => prev.filter(e => e.email !== email));
  }, []);

  return { entries, loading, error, load, add, remove };
}
